import { render, staticRenderFns } from "./AreaCollectorEdit.vue?vue&type=template&id=2968d28c"
import script from "./AreaCollectorEdit.vue?vue&type=script&lang=js"
export * from "./AreaCollectorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports